import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=219f8a43&scoped=true&"
import script from "./AboutMe.vue?vue&type=script&lang=ts&"
export * from "./AboutMe.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=219f8a43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f8a43",
  null
  
)

export default component.exports